import React from "react";
import { motion } from "framer-motion";
import StyledCtaText from "../../common/components/styledCtaText/StyledCtaText";

const Tabs = ({
  data,
  activeCategory,
  handleCategoryClick,
  width,
  custom,
  id,
}) => {
  return (
    <div
      className={`${width} ${
        custom
          ? `grid grid-cols-1 lg:grid-cols-2`
          : `flex gap-4 md:gap-0 justify-evenly  border-bright-yellow border md:rounded-[18px] flex-nowrap overflow-scroll no-scrollbar py-2 px-4`
      }`}
    >
      {data?.map((item, index) => (
        <button
          key={index}
          onClick={() => handleCategoryClick(index, item.Title)}
          className={`relative text-nowrap ${
            activeCategory === item.Title ? "text-black z-10" : "text-white"
          } ${
            custom
              ? "bg-[#3d3d3d] py-2 px-0 min-w-max"
              : "py-2 px-3 md:py-3 md:px-6"
          } rounded-md transition-colors duration-300`}
        >
          <StyledCtaText fontColor={"relative !z-10"}>
            {item.Title}
          </StyledCtaText>
          {activeCategory === item.Title && (
            <motion.span
              layoutId={`pill-tab-${id}`}
              transition={{ type: "spring", duration: 0.6 }}
              className="absolute inset-0 z-0  gradientButton rounded-md"
            ></motion.span>
          )}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
